
import { Label } from "@/components/ui/label";
import { useImageUpload } from "./image-upload/useImageUpload";
import { ImageItem } from "./image-upload/ImageItem";
import { UploadButton } from "./image-upload/UploadButton";
import { EventImage } from "./image-upload/imageUploadUtils";
import { Skeleton } from "@/components/ui/skeleton";

interface ImageUploadSectionProps {
  imageUrl: string;
  imageUrls: string[];
  setImageUrl: (url: string) => void;
  setImageUrls: (urls: string[]) => void;
  eventId?: string;
  // New props for handling direct EventImage array
  eventImages?: EventImage[];
  setEventImages?: (images: EventImage[]) => void;
}

export const ImageUploadSection = ({ 
  imageUrl, 
  imageUrls = [], 
  setImageUrl, 
  setImageUrls,
  eventId,
  eventImages,
  setEventImages
}: ImageUploadSectionProps) => {
  const {
    isUploading,
    isLoading,
    eventImages: hookEventImages,
    allImages,
    handleImageUpload,
    handleRemoveImage,
    handleSetPrimaryImage
  } = useImageUpload({
    imageUrl,
    imageUrls,
    setImageUrl,
    setImageUrls,
    eventId,
    // Pass through the direct event images handling props
    eventImages,
    setEventImages
  });

  // Use either provided eventImages or the hook's internal state
  const imagesToDisplay = eventImages || hookEventImages;

  return (
    <div className="space-y-2">
      <Label>Event Images</Label>
      <div className="grid grid-cols-3 gap-2 sm:grid-cols-4 md:grid-cols-5">
        {isLoading ? (
          // Show skeletons while loading
          Array.from({ length: 3 }).map((_, index) => (
            <Skeleton key={`skeleton-${index}`} className="w-full aspect-square rounded-lg" />
          ))
        ) : (
          // Map over event images, displaying with correct primary indicator
          imagesToDisplay.map((image) => (
            <ImageItem
              key={image.image_id}
              image={image}
              isPrimary={image.is_primary}
              onRemove={handleRemoveImage}
              onSetPrimary={handleSetPrimaryImage}
            />
          ))
        )}
        
        <UploadButton 
          isUploading={isUploading} 
          onChange={handleImageUpload} 
        />
      </div>
      
      <p className="text-xs text-muted-foreground mt-1">
        You can upload multiple images. Click the star to set a primary image.
      </p>
    </div>
  );
};
